import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage } from 'react-intl';

import { RestrictedGateway } from 'src/features/membershipType/types';
import DeleteRestrictedGateway from 'src/features/membership/components/forms/restrictedGateway/DeleteRestrictedGateway';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

interface CellRestrictedGatewayActionsProps<TData, TValue> extends CellContext<TData, TValue> {
    restrictedGateways?: string[];
}
export default function CellRestrictedGatewayActions<TData, TValue>({
    row,
    restrictedGateways,
}: CellRestrictedGatewayActionsProps<TData, TValue>) {
    return (
        <TooltipProvider>
            <Tooltip>
                <DeleteRestrictedGateway
                    selectedRestrictedGateway={row.original as RestrictedGateway}
                    restrictedGateways={restrictedGateways}
                >
                    <TooltipTrigger asChild>
                        <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                            <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                        </Button>
                    </TooltipTrigger>
                </DeleteRestrictedGateway>
                <TooltipContent>
                    <FormattedMessage {...generalMessages.delete} />
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
}
